import {Component, OnInit} from '@angular/core';
import {ChartType, ChartOptions, ChartDataSets} from 'chart.js';
import { Label } from 'ng2-charts';
import {ConfService} from "../conf.service";

@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {
    items:any;
    public barChartOptions: ChartOptions = {
        responsive: true,
    };
    public barChartLabels: Label[] = [];
    public barChartLabelsLatency: Label[] = [];
    public barChartType: ChartType = 'bar';
    public barChartLegend = true;
    public barChartPlugins = [];

    public barChartData: ChartDataSets[] = [
        { data: [], label: 'No. of API Hits' }
    ];
    public barChartDataLatency: ChartDataSets[] = [
        { data: [], label: 'Average Response Time' }
    ];

    constructor(private confPost: ConfService) {

    }

    ngOnInit() {

        // this.confPost.getCloudWatchMetrics(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //     this.items = data;
        //     const value = [];
        //     const label = [];
        //     for (let t = 0; t < this.items.length; t++) {
        //         value.push(parseInt(this.items[t]['y']));
        //         label.push(this.items[t]['label']);
        //     }
        //     this.barChartData[0].data = value;
        //     this.barChartLabels = label;
        // });
        // this.confPost.getCloudWatchLatencyMetrics(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //     this.items = data;
        //     const value = [];
        //     const label = [];
        //     for (let t = 0; t < this.items.length; t++) {
        //         value.push(parseInt(this.items[t]['y']));
        //         label.push(this.items[t]['label']);
        //     }
        //     this.barChartDataLatency[0].data = value;
        //     this.barChartLabelsLatency = label;
        // });
        }
}
